module.exports = __webpack_public_path__ + "img/chat.d88e35ce.svg";